import { useMutation } from 'react-query'
import { endpoints } from '@app/api/config'
import { ApiErrorResponse } from 'BackendApi'
import { apiAuthClient } from '@app/services/apiAuthClient'

// No params required for this endpoint
const postBillingPay = async () => {
  const apiResponse = await apiAuthClient.post(endpoints.billingPay)
  return apiResponse.data
}

export const useBillingPay = () =>
  useMutation<unknown, ApiErrorResponse, void>(postBillingPay)

